import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import request from 'superagent';
import {Tabs} from 'antd';
import moment from 'moment';
import SystemUsageVMList from './SystemUsageVMList.js';
import SystemUsageContainerList from './SystemUsageContainerList.js'
import SystemUsageVMDetail from './SystemUsageVMDetail.js';

class SystemUsageView extends Component {

    cookie = new Cookies();

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            vmData: [],
            ctData: [],
            loading: false,
            showHostName: '',
            intervalId: 0
        };
    }

    componentDidMount() {
        this.fetch();
        var intervalId = setInterval(this.fetch, 5 * 60 * 1000);
        this.setState({intervalId: intervalId});
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    fetch = (emptyTable) => {
        this.setState({loading: true});
        if (emptyTable) {
            this.setState({data: [], vmData: [], ctData: []});
        }
        request.get('/api/dashboard/platform/info')
            .withCredentials()
            .end((error, response) => {
                if (!error && response) {
                    const data = response.body;
                    let vmArray = [];
                    let containerArray = [];
                    for (let i = 0; i < data.length; i++) {
                        data[i].resourceType = data[i].resourceType.toUpperCase();
                        data[i].level = data[i].level.toUpperCase();
                        data[i].appName = data[i].appName.toUpperCase();
                        data[i].used_percent = Math.round(data[i].used_percent);
                        data[i].startTime4Show = moment(data[i].startTime).format("YYYY-MM-DD HH:mm:ss");
                        if (data[i].resourceType === 'CPU') {
                            vmArray.push(data[i]);
                        }
                        if (data[i].resourceType === 'DOCKER_CONTAINER_CPU') {
                            containerArray.push(data[i]);
                        }
                    }

                    // organize vm data
                    const selectVMCookie = this.cookie.get('selectVM');
                    let tmpVM = [];
                    if (selectVMCookie) {
                        tmpVM = selectVMCookie.split(';');
                    }
                    let vmData = [];
                    for (let i = 0; i < vmArray.length; i++) {
                        let vmTemp = {
                            hostName: vmArray[i].hostName,
                            cpu: vmArray[i].used_percent,
                            cpuLevel: vmArray[i].level,
                            ip: vmArray[i].ip,
                            appName: vmArray[i].appName,
                            container: [],
                            alert: [],
                            containerAlert: [],
                            pinned: false
                        }
                        if (vmArray[i].description !== '') {
                            vmTemp.alert.push(vmArray[i].description);
                        }

                        if (tmpVM.indexOf(vmTemp.hostName) !== -1) {
                            vmTemp.pinned = true;
                        }
                        for (let j = 0; j < data.length; j++) {
                            if (data[j].hostName === vmTemp.hostName && data[j].resourceType === 'DISK') {
                                vmTemp.disk = data[j].used_percent;
                                vmTemp.diskLevel = data[j].level;
                                if (data[j].description !== '') {
                                    vmTemp.alert.push(data[j].description);
                                }
                            } else if (data[j].hostName === vmTemp.hostName && data[j].resourceType === 'MEM') {
                                vmTemp.memory = data[j].used_percent;
                                vmTemp.memoryLevel = data[j].level;
                                if (data[j].description !== '') {
                                    vmTemp.alert.push(data[j].description);
                                }
                            } else if (data[j].hostName === vmTemp.hostName && (data[j].resourceType === 'DOCKER_CONTAINER_CPU' || data[j].resourceType === 'DOCKER_CONTAINER_MEM')) {
                                if (!vmTemp.container.includes(data[j].containerID)) {
                                    vmTemp.container.push(data[j].containerID);
                                }
                                if (data[j].description !== '') {
                                    vmTemp.containerAlert.push(data[j].description);
                                }
                            }
                        }
                        vmTemp.container4show = vmTemp.container.toString();
                        vmTemp.containerCount = vmTemp.container.length;
                        vmTemp.alertCount = vmTemp.alert.length + vmTemp.containerAlert.length;
                        vmData.push(vmTemp);
                    }

                    // organize container data
                    let ctData = [];
                    for (let i = 0; i < containerArray.length; i++) {
                        let containerTypeIndex = containerArray[i].containerType.indexOf('/') + 1;
                        let ctTemp = {
                            hostName: containerArray[i].hostName,
                            containerID: containerArray[i].containerID,
                            cpu: containerArray[i].used_percent,
                            cpuLevel: containerArray[i].level,
                            containerType: containerArray[i].containerType.substring(containerTypeIndex),
                            appName: containerArray[i].appName,
                            memory: '',
                            alert: [],
                            servers: containerArray[i].servers,
                            serviceAlertCount: 0,
                            serviceName: '',
                            serviceStatus: ''
                        }
                        if (containerArray[i].servers && containerArray[i].servers.length > 0) {
                            ctTemp.serviceName = containerArray[i].servers[0].ServiceID.split(':')[0];
                            ctTemp.serviceStatus = containerArray[i].servers[0].Status;
                        } else if (containerArray[i].services && containerArray[i].services.length > 0) {
                            ctTemp.serviceStatus = containerArray[i].services[0].Status;
                        }

                        if (containerArray[i].description !== '') {
                            ctTemp.alert.push(containerArray[i].description);
                        }

                        for (let j = 0; j < data.length; j++) {
                            if (data[j].hostName === ctTemp.hostName && data[j].containerID === ctTemp.containerID && data[j].resourceType === 'DOCKER_CONTAINER_MEM') {
                                ctTemp.memory = data[j].used_percent;
                                ctTemp.memoryLevel = data[j].level;
                                if (data[j].description !== '') {
                                    ctTemp.alert.push(data[j].description);
                                }
                            }
                        }
                        ctTemp.alertCount = ctTemp.alert.length;
                        ctData.push(ctTemp);
                    }

                    this.setState({
                        loading: false,
                        data: data,
                        vmData: vmData,
                        ctData: ctData
                    });
                }
            });
    }

    updateShowHostName = (params = {}) => {
        this.setState({showHostName: params});
    }

    closeDetail = () => {
        this.setState({showHostName: ''});
    }

    doPin = () => {
        let selectVMCookie = this.cookie.get('selectVM');
        let hostName = this.state.showHostName;
        let vmData = this.state.vmData;
        if (selectVMCookie) {
            if (selectVMCookie.indexOf(hostName) === -1) {
                selectVMCookie = selectVMCookie + ';' + hostName;
                this.cookie.set('selectVM', selectVMCookie, {expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)});
                for (let i = 0; i < vmData.length; i++) {
                    if (vmData[i].hostName === hostName) {
                        vmData[i].pinned = true;
                        break;
                    }
                }
                this.setState({vmData: vmData});
            } else {
                for (let i = 0; i < vmData.length; i++) {
                    if (vmData[i].hostName === hostName) {
                        vmData[i].pinned = true;
                        break;
                    }
                }
                this.setState({vmData: vmData});
            }
        } else {
            selectVMCookie = hostName;
            this.cookie.set('selectVM', selectVMCookie, {expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)});
            for (let i = 0; i < vmData.length; i++) {
                if (vmData[i].hostName === hostName) {
                    vmData[i].pinned = true;
                    break;
                }
            }
            this.setState({vmData: vmData});
        }
    }

    doUnpin = () => {
        let selectVMCookie = this.cookie.get('selectVM');
        let hostName = this.state.showHostName;
        let vmData = this.state.vmData;
        if (selectVMCookie) {
            let tmpVM = selectVMCookie.split(';');
            tmpVM = tmpVM.filter((vm) => {
                return vm !== hostName;
            });
            let tmpVMCookie = '';
            for (let i = 0; i < tmpVM.length; i++) {
                tmpVMCookie = tmpVMCookie + tmpVM[i] + ';';
            }
            tmpVMCookie = tmpVMCookie.substring(0, tmpVMCookie.length - 1);
            this.cookie.set('selectVM', tmpVMCookie, {expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)});
            for (let i = 0; i < vmData.length; i++) {
                if (vmData[i].hostName === hostName) {
                    vmData[i].pinned = false;
                    break;
                }
            }
            this.setState({vmData: vmData});
        }
    }

    render() {
        const { vmData, ctData, loading, showHostName } = this.state;

        return (
            <div className="page-container">
                <div className={`${showHostName === '' ? 'col-md-12': 'col-md-5'} list`}>
                    <h2 className="page-title">System Usage</h2>
                    <Tabs className="system-usage-tab" type="card">
                        <Tabs.TabPane tab={<span><i className="virtual-machine"/>{vmData.length} Virtual Machines</span>} key="1">
                            <SystemUsageVMList vmData={vmData} loading={loading} showHostName={showHostName}
                                               onFresh={() => this.fetch(true)}
                                               updateShowHostName={this.updateShowHostName}/>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={<span><i className="containers"/>{ctData.length} Containers</span>} key="2" disabled={showHostName !== ''}>
                            <SystemUsageContainerList ctData={ctData} loading={loading} onFresh={() => this.fetch(true)}/>
                        </Tabs.TabPane>
                    </Tabs>
                </div>
                <div className={`${showHostName === '' ? 'col-md-0': 'col-md-7'} detailInfo`}>
                    {showHostName !== '' && (
                        <SystemUsageVMDetail vmData={vmData} ctData={ctData} showHostName={showHostName}
                                             doPin={this.doPin} doUnpin={this.doUnpin} close={this.closeDetail}/>
                    )}
                </div>
            </div>
        );
    }
}
export default SystemUsageView;


// WEBPACK FOOTER //
// ./src/modules/system-usage/SystemUsageView.js